<template>
  <dropdown-menu class="menu-help">
    <template slot="menu-trigger">
      <z-icon
        class="menu-help__icon"
        :class="{
          'menu-help__icon--inverted-medium-screen': invertedInMediumScreen,
          'menu-help__icon--inverted': inverted
        }"
        :icon="['far', 'info-circle']"
        size="large"
      />
      <z-text
        class="menu__item-text"
        :class="{
          'menu-help__icon--inverted-medium-screen': invertedInMediumScreen,
          'menu-help__icon--inverted': inverted
        }"
        tag="span"
        size="medium"
      >
        Ajuda
      </z-text>
    </template>
    <template slot="menu-content">
      <div class="menu__item">
        <z-text
          v-clipboard:copy="whatsappNumber"
          v-clipboard:success="numberCopied"
          class="menu__item-title"
          tag="div"
          color="interactive"
        >
          <z-icon
            :icon="['fab', 'whatsapp']"
            class="menu__item-icon"
          />
          WhatsApp
        </z-text>
        <z-text class="menu__item-description" tag="p" size="small">
          Fale com a gente
          <z-text tag="span" size="small" weight="bold">
            {{ whatsappNumber }}
          </z-text><br>
          Segunda à sexta das 8h às 22h<br>
          Sábado das 9h as 12h
        </z-text>
      </div>
    </template>
  </dropdown-menu>
</template>
<script>
import DropdownMenu from 'components/dropdown-menu';

export default {
  components: {
    DropdownMenu,
  },
  data() {
    return {
      whatsappNumber: '0800 291 7878',
    };
  },
  props: {
    inverted: {
      type: Boolean,
      default: false,
    },
    invertedInMediumScreen: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    numberCopied() {
      this.$toast.show('success', 'Número copiado!', 4000);
    },
  },
};
</script>

<style lang="scss" scoped>
.menu__item {
  cursor: pointer;
}

.menu__item:not(:last-child) {
  margin-bottom: var(--space-medium);
}

.menu__item-link {
  width: 100%;
}

.menu__item-description {
  margin-left: var(--space-large);
}

.menu__item-icon {
  margin-right: var(--space-small);
}

.menu__item-title {
  align-items: center;
  display: flex;
  flex-direction: row;
  white-space: nowrap;
}

.menu-help__icon {
  margin-right: var(--space-small);

  @media screen and (max-width: $screen-md-max) {
    margin: 0;
  }
}

.menu-help {
  margin-right: var(--space-extra-large);

  @media screen and (max-width: $screen-md-max) {
    margin-right: var(--space-medium);
  }
}

.menu-help__icon--inverted {
  color: var(--color-font-inverted);
}

.menu__item-text {
  font-weight: var(--font-weight-medium);

  @media screen and (max-width: $screen-md-max) {
    display: none;
  }
}

.menu__item-text--inverted {
  color: var(--color-font-inverted);
}

.menu-help__icon--inverted-medium-screen {
  @media screen and (max-width: $screen-md-max) {
    color: var(--color-font-inverted);
  }
}

.menu__item-text--inverted-medium-screen {
  @media screen and (max-width: $screen-md-max) {
    color: var(--color-font-inverted);
  }
}
</style>
